import * as localforage from "localforage";
import axios from "axios";

export const getAllPolicyRulesAndEmailsAPI = async () => {
  const company_id = await localforage.getItem("companyId");

  let response = await axios({
    url: `/api/v2/alarm/deploy/alarm-policies`,
    method: "GET",
    params: {
      company_id: company_id
    }
  });
  return response.data.alarm_policies;
};
